import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardPedido from "../CardPedido";
import './index.css';
import { api } from '../../services/api';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button } from 'react-bootstrap';
import RefeicaoPDF from "../RefeicaoPDF/index.jsx";
import Foto from "../../app/Components/Foto";

const fotosCache = new Map();

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18, fontWeight: '500', color: '#444' }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 2000;
                    backdrop-filter: blur(4px);
                }
                .loading-modal-content {
                    background: white;
                    padding: 30px 50px;
                    border-radius: 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                }
            `}</style>
        </div>
    );
}

function Home() {
    const [funcionarios, setFuncionarios] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [pesquisa, setPesquisa] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [confirmacao, setConfirmacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState(false);
    const [status, setStatus] = useState('0');
    const [datahora, setData] = useState('');
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();
    const [codigorest, setCodigoRest] = useState(0);

    function MudarData() {
        const newdata = new Date().toLocaleTimeString();
        setData(newdata);
    }

    function atualizaRefeicao(chapa) {
        setConfirmacao(false);
        api.post('/restaurante/pedido/' + chapa)
            .then(() => {
                setFuncionarios(funcionarios.filter((t) => t.chapa !== chapa));
            })
            .catch((err) => {
                console.log("Erro na liberação: " + err);
                setLoading(false);
            });
    }

    function confirmDeleteUser(chapa, nome) {
        setConfirmacao(true);
        setConfirmacaoId(chapa);
        setNome(nome);
    }

    function abrirModalFoto(foto, nome, chapa) {
        let fotoFormatada = foto;
        if (foto && !foto.startsWith("data:image") && !foto.startsWith("http")) {
            fotoFormatada = `data:image/jpeg;base64,${foto}`;
        }
        setFotoSelecionada({ foto: fotoFormatada, nome, chapa });
    }

    useEffect(() => {
        const cod = localStorage.getItem("codigorest");
        if (cod) setCodigoRest(cod);
    }, []);

    useEffect(() => {
        if (!codigorest) return;
        api.get(`/restaurante/cadastro/${codigorest}`)
        
            .then(response => {
                const lojasExtraidas = response.data[0]?.lojas || [];
                setLojas(lojasExtraidas);
            })
            .catch(err => {
                console.log("Erro ao carregar lojas:", err);
            });
    }, [codigorest]);

    useEffect(() => {
        if (!codigorest) return;
        setLoading(true);
        setLoadingMessage('Consultando registros...');
        setErro(false);

        api.get(`/restaurante/pedido/${codigorest}?loja=${pesquisa}&status=${status}`)
            .then(response => {
                const registros = response.data;
                setFuncionarios(registros.map(r => ({ ...r, foto: null })));
                setLoading(false);
                localStorage.setItem("codigorest", codigorest);

                const hoje = new Date().toISOString().slice(0, 10);
                registros.forEach((funcionario) => {
                    if (fotosCache.has(funcionario.chapa)) {
                        const { data, foto } = fotosCache.get(funcionario.chapa);
                        if (data === hoje && foto) {
                            setFuncionarios(prev => prev.map(item => item.chapa === funcionario.chapa ? { ...item, foto } : item));
                            return;
                        }
                    }
                    api.get(`/usuario/foto/${funcionario.chapa}`)
                        .then(fotoResp => {
                            fotosCache.set(funcionario.chapa, { data: hoje, foto: fotoResp.data.foto });
                            setFuncionarios(prev => prev.map(item => item.chapa === funcionario.chapa ? { ...item, foto: fotoResp.data.foto } : item));
                        })
                        .catch(err => console.log(`Erro foto ${funcionario.chapa}`, err));
                });
            })
            .catch(err => {
                console.log(err);
                setErro(true);
                setLoading(false);
            });
    }, [pesquisa, datahora, status, codigorest]);

    function handleGerarPDF() {
        setLoadingMessage('Gerando arquivo PDF...');
        setLoading(true);
        Promise.resolve(RefeicaoPDF(funcionarios))
            .then(() => setLoading(false))
            .catch((err) => {
                console.log("Erro PDF:", err);
                setLoading(false);
            });
    }

    return (
        <div className="main-wrapper">
            <Menu modulo="REST" />
            <LoadingModal show={loading} message={loadingMessage} />

            <div className="container-fluid pagina-home">
                {/* 🛠 BARRA DE FERRAMENTAS MODERNA */}
                <div className="toolbar-moderna">
                    <div className="toolbar-top">
                        <button onClick={handleGerarPDF} className="btn-pdf-action">
                            <i className="fa fa-file-pdf"></i> <span>Exportar PDF</span>
                        </button>
                        
                        <div className="loja-selector-wrapper">
                            <label>Loja</label>
                            <select
                                className="form-select-moderno"
                                onChange={(e) => setPesquisa(e.target.value)}
                                value={pesquisa}
                            >
                                <option value="0">Todas as Unidades</option>
                                {lojas.map(lj => (
                                    <option key={lj.loja} value={lj.loja}>{lj.loja}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="segmented-control-status">
                        <button 
                            className={`segment-btn ${status === '0' ? 'active warning' : ''}`}
                            onClick={() => setStatus('0')}
                        >
                            <i className={status === '0' ? "fa fa-spinner fa-spin" : "fa fa-clock-o"}></i>
                            <span>Pendentes</span>
                        </button>

                        <button 
                            className={`segment-btn ${status === '1' ? 'active success' : ''}`}
                            onClick={() => setStatus('1')}
                        >
                            <i className="fa fa-check-circle"></i>
                            <span>Confirmadas</span>
                        </button>

                        <button className="segment-btn refresh" onClick={MudarData}>
                            <i className="fa fa-refresh"></i>
                            <span>{datahora === "" ? "Atualizar" : datahora}</span>
                        </button>
                    </div>
                </div>

                {/* 📇 GRID DE CARDS */}
                <div className="row g-3">
                    {funcionarios.map((tabela) => (
                        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6" key={tabela.chapa}>
                            <CardPedido
                                clickDelete={confirmDeleteUser}
                                id={tabela.chapa}
                                chapa={tabela.chapa}
                                nome={tabela.nome}
                                data={tabela.data}
                                marmitex={tabela.marmitex}
                                opcao={tabela.opcao}
                                menu={tabela.menu}
                                observacao={tabela.observacao}
                                status={tabela.status}
                                valor={tabela.valor}
                                loja={tabela.loja}
                                horasol={tabela.horasol}
                                horaeft={tabela.horaeft}
                                foto={tabela.foto}
                                turno={tabela.turno}
                                cor={tabela.chapa > 90000 ? '#66666633' : null}
                                onFotoClick={() => abrirModalFoto(tabela.foto, tabela.nome, tabela.chapa)}
                            />
                        </div>
                    ))}
                    
                    {funcionarios.length === 0 && !loading && (
                        <div className="empty-state">
                            <i className="fa fa-search fa-3x"></i>
                            <p>Nenhum registro encontrado para este filtro.</p>
                        </div>
                    )}
                </div>

                {/* MODAIS */}
                <Modal show={confirmacao} onHide={() => setConfirmacao(false)} centered className="custom-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmar Refeição</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        <p style={{fontSize: '1.1rem'}}>Deseja confirmar a entrega da refeição para:</p>
                        <h4 className="text-primary">{nome}</h4>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={() => setConfirmacao(false)}>Cancelar</Button>
                        <Button variant="success" className="px-4" onClick={() => atualizaRefeicao(confirmacaoId)}>Sim, Confirmar</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={erro} onHide={() => setErro(false)} centered>
                    <Modal.Header closeButton className="bg-danger text-white">
                        <Modal.Title>Erro na Operação</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center py-4">
                        Houve uma falha ao processar a requisição. Tente novamente.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setErro(false)}>Fechar</Button>
                    </Modal.Footer>
                </Modal>

                <Foto
                    show={!!fotoSelecionada}
                    onClose={() => setFotoSelecionada(null)}
                    foto={fotoSelecionada?.foto}
                    nome={fotoSelecionada?.nome}
                    info01={`Chapa: ${fotoSelecionada?.chapa || ''}`}
                    info02=""
                />
            </div>
            {!loading && <Footer />}
        </div>
    );
}

export default Home;